module.exports = __webpack_public_path__ + "static/tri-screen-lockup-6716f702af9bc5e2e8edefe08c3c90b7.png";